module.exports = __webpack_public_path__ + "static/41import-6a0a99472b499b0de0f3e45f8aea0cd4.png";